const configs = {
  API_DOMAIN: process.env.REACT_APP_BASE_URL,
};

export default configs;
